import { Routes } from '@angular/router';
import {
  VrskOktaLoginFlowComponent,
  VrskGatewayLoginGuard,
  VrskAuthOktaLogoutComponent,
  VrskAuthOktaCallbackComponent
} from '@uw-verisk/auth-okta';
import { RoleGuard } from './components/shared/guards/role-guard';

export const rootRouterConfig: Routes = [
  {
    path: `auth/oktaLoginFlow`,
    component: VrskOktaLoginFlowComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'file-explorer',
    canActivate: [RoleGuard ,VrskGatewayLoginGuard],
  },
  { path: 'auth/callback', component: VrskAuthOktaCallbackComponent },
  { path: 'auth/logged-out', pathMatch: 'full', redirectTo: 'file-explorer' },
  {
    path: 'auth/logout',
    component: VrskAuthOktaLogoutComponent,
  },
  {
    path: 'recipe',
    canActivate: [RoleGuard ,VrskGatewayLoginGuard],
    loadChildren: () =>
      import('./feature-recipe/recipe.module').then((m) => m.MergeModule),
  },
  {
    path: 'file-explorer',
    canActivate: [RoleGuard ,VrskGatewayLoginGuard],
    loadChildren: () =>
      import('./feature-file-explorer/file-explorer.module').then(
        (m) => m.FileExplorerModule
      ),
  },
  {
    path: 'customer',
    canActivate: [RoleGuard, VrskGatewayLoginGuard],
    loadChildren: () =>
      import('./customer/customer.module').then((m) => m.CustomerModule),
  },
  {
    path: 'dataset',
    canActivate: [RoleGuard ,VrskGatewayLoginGuard],
    loadChildren: () =>
      import('./dataset/dataset.module').then((m) => m.DatasetModule),
  },
  {
    path: 'reports',
    // each route in reports module has its own role guard
    // canActivate: [RoleGuard ,VrskGatewayLoginGuard],
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
  },
];
